angular.module('unica_invitation_group.invitation_group_controllers')

.controller('InvitationGroupEditController', function(
	$rootScope, $scope, $state, $stateParams,
	InvitationGroupEditService
) {

	$scope.event_id = $stateParams.event_id;
	$scope.id       = $stateParams.id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.getInvitationGroup( $stateParams.id );

	$scope.saveInvitationGroup = function()
	{
		$scope.showLoader();

		InvitationGroupEditService
			.update( $scope.invitationGroupData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Notifica aggiornata con successo!', '');

					//$state.go('app.hospitality.room_list', { event_id: $stateParams.event_id });
				}
			});
	};

});